export default class ValidationInfo {
  public prefix: string | undefined;
  public errors: string[];
  public validated: boolean;
  public children: { [key: string]: ValidationInfo } = {};

  constructor(prefix?: string | undefined, errors?: string[] | undefined, children?: { [key: string]: ValidationInfo } | undefined) {
    this.prefix = prefix;
    this.validated = errors !== undefined;
    this.errors = errors ?? [];
    this.children = children ?? {};
  }

  public get isValid(): boolean {
    return this.validated && this.errors.length === 0 && Object.values(this.children).every((child) => child.isValid);
  }

  public get isInvalid(): boolean {
    return this.validated && (this.errors.length > 0 || Object.values(this.children).some((child) => child.isInvalid));
  }

  public getErrors(): string[] {
    return this.errors;
  }

  public getErrorsWithPrefix(): string[] {
    return this.errors.map((e) => `${this.prefix ?? ''}${e}`);
  }
}
